// Minimal email-safe CSS for Lexical-generated content.
// This focuses on core typography so emails render consistently.
export const defaultEmailLexicalCSS = `
/* Direction helpers */
.ltr { text-align: left; }
.rtl { text-align: right; }

/* Text styles */
.editor-text-bold { font-weight: bold; }
.editor-text-italic { font-style: italic; }
.editor-text-underline { text-decoration: underline; }
.editor-text-strikethrough { text-decoration: line-through; }
.editor-text-underlineStrikethrough { text-decoration: underline line-through; }
.editor-text-code { background-color: #f0f2f5; padding: 1px 0.25rem; font-family: Menlo, Consolas, Monaco, monospace; font-size: 94%; }

/* Links */
.editor-link { color: #216fdb; text-decoration: none; }

/* Paragraphs & Headings */
.editor-paragraph { margin: 0; margin-bottom: 8px; position: relative; overflow: hidden; }
.editor-paragraph:last-child { margin-bottom: 0; }
.editor-heading-h1 { font-size: 26px; color: #333; font-weight: 600; margin: 0 0 12px 0; padding: 0; }
.editor-heading-h2 { font-size: 20px; color: #333; font-weight: 600; margin: 10px 0 0 0; padding: 0; }
.editor-quote { margin: 0 0 0 20px; font-size: 15px; color: #65676b; border-left: 4px solid #ced0d4; padding-left: 16px; }

/* Lists */
.editor-list-ol { padding: 0; margin: 0 0 0 16px; list-style-type: decimal; }
.editor-list-ul { padding: 0; margin: 0 0 0 16px; list-style-type: disc; }
.editor-listitem { margin: 0 0 6px 0; }
.editor-nested-listitem { list-style-type: none; }

/* Code blocks */
.editor-code { background-color: #f0f2f5; font-family: Menlo, Consolas, Monaco, monospace; display: block; padding: 8px; line-height: 1.53; font-size: 13px; margin: 8px 0; overflow-x: auto; }
`;

export default defaultEmailLexicalCSS;

